const StateAgencies = () => {
  const agencies = [
    {
      name: 'Department of Developmental Services',
      logo: '/images/Logo05.webp',
      url: 'https://www.dds.ca.gov/',
      website: 'www.dds.ca.gov'
    },
    {
      name: 'Eastern Los Angeles Regional Center',
      logo: '/images/Logo06.webp',
      url: 'https://www.elarc.org/',
      website: 'www.elarc.org'
    },
    {
      name: 'Frank D. Lanterman Regional Center',
      logo: '/images/Logo01-1.webp',
      url: 'https://lanterman.org/',
      website: 'lanterman.org'
    },
    {
      name: 'San Gabriel Pomona Regional Center',
      logo: '/images/Logo02.webp',
      url: 'https://www.sgprc.org/',
      website: 'www.sgprc.org'
    },
    {
      name: 'Adult Protective Services',
      logo: '/images/Logo04.webp',
      url: '#',
      website: ''
    },
    {
      name: 'Department of Social Services/Community Care Licensing',
      logo: '/images/cdss-logo.png',
      url: 'https://www.cdss.ca.gov/inforesources/community-care-licensing',
      website: 'www.cdss.ca.gov'
    }
  ];

  return (
    <section className="py-28 px-4 bg-indigo-600">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <div className="inline-block mb-4">
            <span className="text-white font-semibold text-sm uppercase tracking-wider bg-white/20 px-5 py-2 rounded-full">Our Partners</span>
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6 leading-tight">State Agencies We Work With</h2>
          <p className="text-xl text-white/90 max-w-3xl mx-auto leading-relaxed">
            Proud partners with leading regional centers across California
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {agencies.map((agency, index) => (
            <div 
              key={index}
              className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all hover:-translate-y-2 cursor-pointer group"
            >
              <div className="flex flex-col items-center text-center h-full">
                <div className="w-full h-32 flex items-center justify-center mb-6">
                  <img 
                    src={agency.logo}
                    alt={agency.name}
                    className="max-w-full max-h-full object-contain group-hover:scale-105 transition-transform"
                  />
                </div>
                <h3 className="text-base font-semibold text-gray-900 mb-2 leading-snug">
                  {agency.name}
                </h3>
                {agency.website && (
                  <p className="text-sm text-purple-600 group-hover:underline flex items-center gap-1">
                    {agency.website}
                    <i className="ri-external-link-line text-xs"></i>
                  </p>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StateAgencies;
